import { useEffect, useState } from "react";
import { MessageCircle, LifeBuoy, CheckCircle2, RotateCcw } from "lucide-react";
import { api } from "@/lib/api";
import { ThreadView, SUPPORT_STATUS } from "@/components/support/ThreadView";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

export default function AdminSupportPage() {
  const [items, setItems] = useState([]);
  const [kind, setKind] = useState("ALL");
  const [sel, setSel] = useState(null);
  const load = () => api.get("/admin/support/threads", { params: kind === "ALL" ? {} : { kind } }).then((r) => setItems(r.data));
  useEffect(() => { load(); const t = setInterval(load, 8000); return () => clearInterval(t); }, [kind]);
  const current = items.find((x) => x.id === sel);
  const setStatus = async (status) => { await api.put(`/admin/support/threads/${sel}/status`, { status }); load(); };

  return (
    <div className="space-y-6" data-testid="admin-support-page">
      <div>
        <div className="text-xs uppercase tracking-wider text-slate-500 font-semibold mb-1">Süper Admin</div>
        <h1 className="text-4xl font-extrabold tracking-tight text-slate-900" style={{ fontFamily: "Outfit, sans-serif" }}>Destek</h1>
        <p className="text-slate-500 mt-1">Canlı destek sohbetleri ve destek taleplerini yanıtlayın.</p>
      </div>
      <Tabs value={kind} onValueChange={setKind}>
        <TabsList>
          <TabsTrigger value="ALL" data-testid="support-tab-all">Tümü</TabsTrigger>
          <TabsTrigger value="CHAT" data-testid="support-tab-chat">Canlı destek</TabsTrigger>
          <TabsTrigger value="TICKET" data-testid="support-tab-ticket">Destek talepleri</TabsTrigger>
        </TabsList>
      </Tabs>
      <div className="grid lg:grid-cols-[360px_1fr] gap-4 items-start">
        <Card className="divide-y max-h-[640px] overflow-y-auto" data-testid="support-thread-list">
          {items.length === 0 && <div className="p-8 text-center text-sm text-slate-500">Kayıt yok</div>}
          {items.map((t) => (
            <button key={t.id} data-testid={`support-thread-${t.ticket_no}`} onClick={() => setSel(t.id)} className={`w-full text-left p-3 hover:bg-slate-50 ${sel === t.id ? "bg-slate-100" : ""}`}>
              <div className="flex items-center gap-2">
                {t.kind === "CHAT" ? <MessageCircle className="w-4 h-4 text-emerald-600" /> : <LifeBuoy className="w-4 h-4 text-sky-600" />}
                <span className="font-medium text-sm truncate flex-1">{t.office_name} · {t.name}</span>
                {t.unread_admin && <span className="w-2 h-2 rounded-full bg-red-500" data-testid={`support-unread-${t.ticket_no}`} />}
              </div>
              <div className="text-xs text-slate-500 truncate mt-0.5">{t.ticket_no} · {t.subject} · {SUPPORT_STATUS[t.status]}</div>
              <div className="text-xs text-slate-400 truncate">{t.last_message}</div>
            </button>
          ))}
        </Card>
        <Card className="h-[640px] flex flex-col overflow-hidden">
          {!current ? <div className="m-auto text-sm text-slate-500">Bir görüşme seçin</div> : (
            <>
              <div className="p-3 border-b flex items-center justify-between gap-3">
                <div className="min-w-0">
                  <div className="font-semibold truncate">{current.subject}</div>
                  <div className="text-xs text-slate-500">{current.office_name} ({current.office_code}) · {current.name} · <a className="underline" href={`mailto:${current.email}`}>{current.email}</a></div>
                </div>
                <div className="flex items-center gap-2 shrink-0">
                  <Badge variant="outline">{SUPPORT_STATUS[current.status]}</Badge>
                  {current.status !== "CLOSED"
                    ? <Button size="sm" variant="outline" data-testid="support-close-btn" onClick={() => setStatus("CLOSED")}><CheckCircle2 className="w-4 h-4 mr-1" />Kapat</Button>
                    : <Button size="sm" variant="outline" data-testid="support-reopen-btn" onClick={() => setStatus("OPEN")}><RotateCcw className="w-4 h-4 mr-1" />Yeniden aç</Button>}
                </div>
              </div>
              <div className="flex-1 min-h-0"><ThreadView key={current.id + current.status} threadId={current.id} admin onChanged={load} /></div>
            </>
          )}
        </Card>
      </div>
    </div>
  );
}
